import React from 'react'
import { useSelector } from 'react-redux'
import {
  DataTable, Table, TableBody, TableCell, TableContainer,
  TableHead, TableHeader, TableRow, TableToolbar, TableToolbarContent,
  TableToolbarSearch, Button
} from '@carbon/react';
import { useSorting } from '../../../modules/hooks/sorting';

const MetricsTable = _ => {
  const { data } = useSelector(state => state.metrics)

  const headerData = [
    {
      header: 'Camión', // This corresponds to the truckPatent field
      key: 'primary_name',
    },
    {
      header: 'Fecha', // This corresponds to the inicio_descarga field
      key: 'event_time',
      sortDirection: 'DESC',
    },
    {
      header: 'Odómetro', // This corresponds to the fin_descarga field
      key: 'ecu_dist__km',
    },
    {
      header: 'Horómetro', // This corresponds to the geocerca field
      key: 'ecu_hours',
    },
    {
      header: 'dev_ign', // This corresponds to the geocerca field
      key: 'dev_ign',
    },
  ];

  const convertToCSV = (data) => {
    // Define the new headers and their mapping to the old ones
    const headerMapping = {
      'primary_name': 'Camión',
      'event_time': 'Fecha',
      'ecu_dist__km': 'Odómetro',
      'ecu_hours': 'Horómetro',
      'dev_ign': 'dev_ign'
    };

    if (data.length === 0) {
      return '';
    }

    const headers = Object.values(headerMapping).join(',') + '\n';

    const rows = data.map(row => {
      return Object.keys(headerMapping).map(key => {
        let value = row[key];
        // Check if the value is a number
        if (!isNaN(value) && value.toString().indexOf('.') !== -1) {
          // If it's a number with a dot, replace the dot with a comma
          value = value.toString().replace('.', ',');
        }
        return `"${value}"`; // Apply text formatting to all fields
      }).join(',');
    }).join('\n');

    return headers + rows;
  };

  const downloadCSV = (csvContent, fileName = 'download.csv') => {
    // Create a Blob with the CSV content
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    // Create a hidden link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    // Append link to the body, click it, and then remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = () => {
    const csv = convertToCSV(data);

    downloadCSV(csv, 'Horómetros y Odómetros.csv');
  };

  const { rows, headers } = useSorting(data, headerData);

  const Default = () => (
    <DataTable rows={rows} headers={headers} width="100%">
      {({
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getTableProps,
        getTableContainerProps,
        onInputChange,
        sortBy,
      }) => (
        <TableContainer {...getTableContainerProps()}>
          <TableToolbar>
            <TableToolbarContent>
              <TableToolbarSearch onChange={onInputChange} />
              <Button onClick={handleDownload}>Descargar</Button>
            </TableToolbarContent>
          </TableToolbar>
          <Table {...getTableProps()} aria-label="sample table">
            <TableHead>
              <TableRow>
                {headers.map((header, i) => {
                  const { key: _unusedKey, ...headerProps } = getHeaderProps({
                    header,
                    isSortable:
                      (headerData[i]?.sortDirection ?? "NONE") !== "NONE",
                    onClick: (_, sortState) => sortBy(sortState.sortHeaderKey),
                  });

                  return (
                    <TableHeader
                      key={i}
                      sortDirection={headerData[i]?.sortDirection ?? "NONE"}
                      {...headerProps}
                    >
                      {header.header}
                    </TableHeader>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                const { key: _unusedKey, ...rowProps } = getRowProps({ row });

                return (
                  <React.Fragment key={row.id}>
                    <TableRow {...rowProps}>
                      {row.cells.map((cell) => (
                        <TableCell key={cell.id}>{cell.value}</TableCell>
                      ))}
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DataTable>
  );

  return (
    <Default />
  )
}

export default MetricsTable;